<template>
  <div class="menu-wrapper">
    <template v-for="item in routes" style="height:50%;">


      <el-menu-item v-if="!item.children || item.children.length == 0" :index="item.path"
        :class="{ 'submenu-title-noDropdown': !isNest }" :key="item.path">
        <svg-icon v-if="item.icon" :icon-class="item.icon"></svg-icon>
        <span v-if="item.title" slot="title">{{ item.title }}</span>
      </el-menu-item>


      <el-submenu v-else :index="item.path" :key="item.title">
        <template slot="title">
          <svg-icon v-if="item.icon" :icon-class="item.icon"></svg-icon>
          <span v-if="item.title" slot="title">{{ item.title }}</span>
        </template>

        <template v-for="child in item.children">
          <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children && child.children.length > 0"
            :routes="[child]" :key="child.title"></sidebar-item>


          <el-menu-item v-else :index="child.path" :key="child.path">
            <svg-icon v-if="child.icon" :icon-class="child.icon"></svg-icon>
            <span v-if="child.title" slot="title">{{ child.title }}</span>
          </el-menu-item>

        </template>
      </el-submenu>

    </template>
  </div>
</template>

<script>
import { generateTitle } from '@/utils/i18n'

export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hasOneShowingChildren (children) {
      const showingChildren = children.filter(item => {
        return !item.hidden
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    },
    generateTitle
  }
}
</script>
<style scoped>
.svg-icon {
  width: 1.3em !important;
  height: 1.3em !important;
  vertical-align: middle !important;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue